import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "core-js/modules/es6.regexp.to-string";
import _JSON$stringify from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/json/stringify";
import _Object$keys from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.replace";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";

/*
 * @Author: Jhonsem
 * @Date: 2019-03-19 18:40:31
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2019-03-19 19:02:40
 */
import { getLang, getUUid, getDateStr } from "../utils/apiHelper";
import * as constants from "./constants";
import HttpClient from "../http/index";

var CryptoJS = require("crypto-js");

import { clientError } from "@/api/utils/apiHelper";

var HoroScopeClient =
/*#__PURE__*/
function () {
  function HoroScopeClient() {
    _classCallCheck(this, HoroScopeClient);
  }

  _createClass(HoroScopeClient, [{
    key: "safeUrl",
    value: function safeUrl(str) {
      // "+" => "-", "/" => "_", "=" => ""
      str = str.replace(/\+/g, "-");
      str = str.replace(/\//g, "_");
      str = str.replace(/\=/g, "");
      return str;
    }
  }, {
    key: "sortQuery",
    value: function sortQuery(req) {
      var params = req.params;
      var keys = [];

      var _arr = _Object$keys(params);

      for (var _i = 0; _i < _arr.length; _i++) {
        var key = _arr[_i];
        keys.push(key);
      }

      keys.sort(); // 字典排序

      var pairs = [];

      for (var _i2 = 0; _i2 < keys.length; _i2++) {
        var _key = keys[_i2];
        pairs.push("".concat(_key, "=").concat(params[_key]));
      }

      var paramsString = pairs.join("&");
      console.log("paramsString:", paramsString);
      delete req.params;
      return "?" + paramsString;
    }
  }, {
    key: "BKDRHash",
    value: function BKDRHash(str) {
      var seed = 131;
      var hash = 0;

      for (var i = 0; i < str.length; i++) {
        hash = hash * seed + str.charCodeAt(i);
        hash ^= 0xffffffff; // 溢出部分截断,只取32bit
      }

      return hash ^ 0x7fffffff;
    }
    /**
     * // 1-12, 1=白羊座
     * @param month
     * @param day
     */

  }, {
    key: "getAstro",
    value: function getAstro(month, day) {
      var arr = [20, 19, 21, 21, 21, 22, 23, 23, 23, 23, 22, 22];
      var result = (month - (day < arr[month - 1] ? 1 : 0) + 10) % 12;
      return result ? result : 12;
    }
  }, {
    key: "requestCommonFactory",
    value: function requestCommonFactory() {
      var vision = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var methods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GET";
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "HORO";
      var req = {};
      var client = {};
      req.headers = {};
      client.channel = 200;
      client.country = "US"; // 该值应该跟随真机,这里只给出默认值

      client.app_version = "48";
      client.system_version_name = "12.1.3"; // 该值应该跟随真机,这里只给出默认值

      client.dtype = 2;
      client.lang = this.language;

      if (type === "NEW") {
        client.package_name = constants.NEW_PACKAGE_NAME;
        req.headers["User-Agent"] = constants.NEW_UA;
      } else {
        client.package_name = constants.PACKAGE_NAME;
        req.headers["User-Agent"] = constants.UA;
      }

      if (vision) {
        client.did = this.deviceId;
      } else {
        client.aid = this.deviceId;
      } // console.log("client:", client);


      var stringUtf = CryptoJS.enc.Utf8.parse(_JSON$stringify(client));
      var base64string = CryptoJS.enc.Base64.stringify(stringUtf);
      var safeUrlRes = this.safeUrl(base64string);

      if (methods === "GET") {
        req.params = {};
        req.params.api_key = constants.API_KEY;
        req.params.client_lang = this.language;
        req.params.timestamp = Math.floor(new Date().getTime() / 1000).toString();

        if (vision) {
          req.params.device = safeUrlRes;
        } else {
          req.params.client = safeUrlRes;
        }
      } else {
        req.data = {};
        req.data.api_key = constants.API_KEY;
        req.data.client_lang = this.language;
        req.data.timestamp = Math.floor(new Date().getTime() / 1000).toString();

        if (vision) {
          req.data.device = safeUrlRes;
        } else {
          req.data.client = safeUrlRes;
        }
      }

      return req;
    }
  }, {
    key: "signRequestHeaders",
    value: function signRequestHeaders(req) {
      // req.params 是一个Object,在序列化时应采用name的字典排序
      var keys = [];

      var _arr2 = _Object$keys(req.params);

      for (var _i3 = 0; _i3 < _arr2.length; _i3++) {
        var key = _arr2[_i3];
        keys.push(key);
      }

      keys.sort(); // 字典排序

      var pairs = [];

      for (var _i4 = 0; _i4 < keys.length; _i4++) {
        var _key2 = keys[_i4];
        pairs.push("".concat(_key2, "=").concat(req.params[_key2]));
      }

      var queryString = pairs.join("&"); // console.log("queryString:", queryString);

      var str = [req.method, req.path, queryString, ""].join("\n"); // console.log("str:", str);
      // 请自行引入HmacSHA256算法

      str = CryptoJS.HmacSHA256(str, constants.SECRET_KEY); // hash后直接对Buffer的数据进行base64,不要进行十六进制编码
      // console.log("str:", str);

      str = CryptoJS.enc.Base64.stringify(str); // console.log("str:", str);

      str = this.safeUrl(str); // console.log("str:", str);

      req.headers["Authorization"] = str;
    }
    /**
     * 星座标识 1-12,白羊座起始
     * @param sign
     */

  }, {
    key: "req_horo_today",
    value: function req_horo_today(sign) {
      var _this = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  req = _this.requestCommonFactory();
                  req.method = "GET";
                  req.path = constants.HORO_TODAY_PATH;
                  req.params.is_tomorrow = "0";
                  req.params.sign = sign.toString();
                  req.params.date = getDateStr();

                  _this.signRequestHeaders(req);

                  _context.next = 10;
                  return HttpClient.get(constants.BASE_URL + constants.HORO_TODAY_PATH, req);

                case 10:
                  res = _context.sent;
                  resolve(res);
                  _context.next = 18;
                  break;

                case 14:
                  _context.prev = 14;
                  _context.t0 = _context["catch"](0);
                  clientError("req_horo_today", _context.t0);
                  reject(_context.t0);

                case 18:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 14]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
    /**
     * 明日运势
     * @param sign
     */

  }, {
    key: "req_horo_tomorrow",
    value: function req_horo_tomorrow(sign) {
      var _this2 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  req = _this2.requestCommonFactory();
                  req.method = "GET";
                  req.path = constants.HORO_TOMORROW_PATH;
                  req.params.is_tomorrow = "1";
                  req.params.sign = sign.toString();
                  req.params.date = getDateStr("tomorrow");

                  _this2.signRequestHeaders(req);

                  _context2.next = 10;
                  return HttpClient.get(constants.BASE_URL + constants.HORO_TOMORROW_PATH, req);

                case 10:
                  res = _context2.sent;
                  resolve(res);
                  _context2.next = 18;
                  break;

                case 14:
                  _context2.prev = 14;
                  _context2.t0 = _context2["catch"](0);
                  clientError("req_horo_tomorrow", _context2.t0);
                  reject(_context2.t0);

                case 18:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 14]]);
        }));

        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
    /**
     * 一周的运势
     * @param sign
     */

  }, {
    key: "req_horo_week",
    value: function req_horo_week(sign) {
      var _this3 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref3 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee3(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  req = _this3.requestCommonFactory();
                  req.method = "GET";
                  req.path = constants.HORO_TODAY_PATH;
                  req.params.sign = sign.toString();
                  req.params.date = getDateStr("week");

                  _this3.signRequestHeaders(req);

                  _context3.next = 9;
                  return HttpClient.get(constants.BASE_URL + constants.HORO_WEEK_PATH, req);

                case 9:
                  res = _context3.sent;
                  resolve(res);
                  _context3.next = 17;
                  break;

                case 13:
                  _context3.prev = 13;
                  _context3.t0 = _context3["catch"](0);
                  clientError("req_horo_week", _context3.t0);
                  reject(_context3.t0);

                case 17:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[0, 13]]);
        }));

        return function (_x5, _x6) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
    /**
     * 一个月的运势
     * @param sign
     */

  }, {
    key: "req_horo_month",
    value: function req_horo_month(sign) {
      var _this4 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref4 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee4(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  req = _this4.requestCommonFactory();
                  req.method = "GET";
                  req.path = constants.HORO_MONTH_PATH;
                  req.params.sign = sign.toString();
                  req.params.month = getDateStr("month");

                  _this4.signRequestHeaders(req);

                  _context4.next = 9;
                  return HttpClient.get(constants.BASE_URL + constants.HORO_MONTH_PATH, req);

                case 9:
                  res = _context4.sent;
                  resolve(res);
                  _context4.next = 17;
                  break;

                case 13:
                  _context4.prev = 13;
                  _context4.t0 = _context4["catch"](0);
                  clientError("req_horo_month", _context4.t0);
                  reject(_context4.t0);

                case 17:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[0, 13]]);
        }));

        return function (_x7, _x8) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
    /**
     * 一年的运势
     * @param sign
     */

  }, {
    key: "req_horo_year",
    value: function req_horo_year(sign) {
      var _this5 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref5 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee5(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.prev = 0;
                  req = _this5.requestCommonFactory();
                  req.method = "GET";
                  req.path = constants.HORO_YEAR_PATH;
                  req.params.sign = sign.toString();
                  req.params.year = getDateStr("year");

                  _this5.signRequestHeaders(req);

                  _context5.next = 9;
                  return HttpClient.get(constants.BASE_URL + constants.HORO_YEAR_PATH, req);

                case 9:
                  res = _context5.sent;
                  resolve(res);
                  _context5.next = 17;
                  break;

                case 13:
                  _context5.prev = 13;
                  _context5.t0 = _context5["catch"](0);
                  clientError("req_horo_year", _context5.t0);
                  reject(_context5.t0);

                case 17:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, null, [[0, 13]]);
        }));

        return function (_x9, _x10) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "req_person_future",
    value: function req_person_future(name, birthday_month, birthday_day) {
      var _this6 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref6 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee6(resolve, reject) {
          var req, queryString, req_url, res;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.prev = 0;
                  req = _this6.requestCommonFactory(true);
                  req.method = "GET";
                  req.path = constants.HORO_PERSON_FUTURE_PATH;
                  req.params.age = "0"; // req.params.bucket = "vision-service-static";

                  req.params.code = _this6.BKDRHash(name).toString();
                  req.params.day = ("00" + birthday_day).slice(-2);
                  req.params.month = ("00" + birthday_month).slice(-2);
                  req.params.sign = _this6.getAstro(birthday_month, birthday_day).toString();

                  _this6.signRequestHeaders(req);

                  queryString = _this6.sortQuery(req);
                  req_url = constants.BASE_URL_VISION + constants.HORO_PERSON_FUTURE_PATH + queryString; // console.log("req_url", req_url);
                  // console.log("req", req);

                  _context6.next = 14;
                  return HttpClient.get(req_url, req);

                case 14:
                  res = _context6.sent;
                  resolve(res);
                  _context6.next = 22;
                  break;

                case 18:
                  _context6.prev = 18;
                  _context6.t0 = _context6["catch"](0);
                  clientError("req_person_future", _context6.t0);
                  reject(_context6.t0);

                case 22:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, null, [[0, 18]]);
        }));

        return function (_x11, _x12) {
          return _ref6.apply(this, arguments);
        };
      }());
    }
    /**
     * 今日首相
     * @param sign
     */

  }, {
    key: "req_hands_today",
    value: function req_hands_today(sign) {
      var _this7 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref7 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee7(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.prev = 0;
                  req = _this7.requestCommonFactory(false, "GET", "NEW");
                  req.method = "GET";
                  req.path = constants.HORO_TODAY_PATH;
                  req.params.is_tomorrow = "0";
                  req.params.sign = sign.toString();
                  req.params.date = getDateStr();

                  _this7.signRequestHeaders(req);

                  _context7.next = 10;
                  return HttpClient.get(constants.NEW_BASE_URL + constants.HORO_TODAY_PATH, req);

                case 10:
                  res = _context7.sent;
                  resolve(res);
                  _context7.next = 18;
                  break;

                case 14:
                  _context7.prev = 14;
                  _context7.t0 = _context7["catch"](0);
                  clientError("req_hands_today", _context7.t0);
                  reject(_context7.t0);

                case 18:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, null, [[0, 14]]);
        }));

        return function (_x13, _x14) {
          return _ref7.apply(this, arguments);
        };
      }());
    } // 爱情顾问

  }, {
    key: "req_love_report",
    value: function req_love_report(name, birthday_month, birthday_day) {
      var _this8 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref8 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee8(resolve, reject) {
          var req, month, day, queryString, req_url, res;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.prev = 0;
                  req = _this8.requestCommonFactory(true, "GET", "NEW");
                  month = ("00" + birthday_month).slice(-2);
                  day = ("00" + birthday_day).slice(-2);
                  req.method = "GET";
                  req.path = constants.LOVA_REPORT_PATH;
                  req.params.sign = _this8.getAstro(birthday_month, birthday_day).toString();
                  console.log(birthday_month, birthday_day);
                  console.log(_this8.getAstro(birthday_month, birthday_day).toString());
                  req.params.code = _this8.BKDRHash(name + "-" + month + "-" + day).toString();
                  console.log('req', req);

                  _this8.signRequestHeaders(req);

                  queryString = _this8.sortQuery(req);
                  console.log("queryString", queryString);
                  req_url = constants.NEW_BASE_URL_VISION + constants.LOVA_REPORT_PATH + queryString;
                  console.log('req_url', req_url);
                  _context8.next = 18;
                  return HttpClient.get(req_url, req);

                case 18:
                  res = _context8.sent;
                  resolve(res); // commit

                  _context8.next = 26;
                  break;

                case 22:
                  _context8.prev = 22;
                  _context8.t0 = _context8["catch"](0);
                  reject(_context8.t0);
                  clientError("req_love_report", _context8.t0);

                case 26:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, null, [[0, 22]]);
        }));

        return function (_x15, _x16) {
          return _ref8.apply(this, arguments);
        };
      }());
    } // 财富预测

  }, {
    key: "req_wealth_report",
    value: function req_wealth_report(name, birthday_month, birthday_day) {
      var _this9 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref9 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee9(resolve, reject) {
          var req, month, day, queryString, req_url, res;
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.prev = 0;
                  req = _this9.requestCommonFactory(true, "GET", "NEW");
                  month = ("00" + birthday_month).slice(-2);
                  day = ("00" + birthday_day).slice(-2);
                  req.method = "GET";
                  req.path = constants.WEALTH_REPORT_PATH;
                  req.params.sign = _this9.getAstro(birthday_month, birthday_day).toString();
                  req.params.code = _this9.BKDRHash(name + "-" + month + "-" + day).toString();

                  _this9.signRequestHeaders(req);

                  queryString = _this9.sortQuery(req);
                  req_url = constants.NEW_BASE_URL_VISION + constants.WEALTH_REPORT_PATH + queryString;
                  _context9.next = 13;
                  return HttpClient.get(req_url, req);

                case 13:
                  res = _context9.sent;
                  resolve(res);
                  _context9.next = 21;
                  break;

                case 17:
                  _context9.prev = 17;
                  _context9.t0 = _context9["catch"](0);
                  reject(_context9.t0);
                  clientError("req_wealth_report", _context9.t0);

                case 21:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, null, [[0, 17]]);
        }));

        return function (_x17, _x18) {
          return _ref9.apply(this, arguments);
        };
      }()); // commit
    } // 掌纹匹配
    // 预先请求 req_palm_detect_compatibility() 仅判断是否有手掌
    // sign1和sign2是你和Ta的星座

  }, {
    key: "req_palm_compatibility",
    value: function req_palm_compatibility(birthday_month_1, birthday_day_1, birthday_month_2, birthday_day_2) {
      var _this10 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref10 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee10(resolve, reject) {
          var req, queryString, req_url, res;
          return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.prev = 0;
                  req = _this10.requestCommonFactory(false, "GET", "NEW");
                  req.method = "GET";
                  req.path = constants.PALM_COMPATIBILITY_PATH;
                  req.params.sign1 = _this10.getAstro(birthday_month_1, birthday_day_1).toString();
                  req.params.sign2 = _this10.getAstro(birthday_month_2, birthday_day_2).toString();

                  _this10.signRequestHeaders(req);

                  queryString = _this10.sortQuery(req);
                  req_url = constants.NEW_BASE_URL + constants.PALM_COMPATIBILITY_PATH + queryString;
                  _context10.next = 11;
                  return HttpClient.get(req_url, req);

                case 11:
                  res = _context10.sent;
                  resolve(res);
                  _context10.next = 19;
                  break;

                case 15:
                  _context10.prev = 15;
                  _context10.t0 = _context10["catch"](0);
                  reject(_context10.t0);
                  clientError("req_palm_compatibility", _context10.t0);

                case 19:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, null, [[0, 15]]);
        }));

        return function (_x19, _x20) {
          return _ref10.apply(this, arguments);
        };
      }()); // commit
    }
  }, {
    key: "language",
    get: function get() {
      return getLang();
    }
  }, {
    key: "deviceId",
    get: function get() {
      return getUUid();
    }
  }]);

  return HoroScopeClient;
}();

export default new HoroScopeClient();